import React, { useState } from "react";
import { Stack, Paper, Icon, Typography, alpha, useTheme } from "@mui/material";

interface PaymentMethod {
  id: string;
  label: string;
  icon: string;
}

interface PaymentMethodSelectorProps {
  selectedPayment: string;
  onSelectPayment: (method: string) => void;
}

const PAYMENT_METHODS: PaymentMethod[] = [
  { id: "cash", label: "Cash", icon: "payments" },
  { id: "mastercard", label: "Mastercard", icon: "credit_card" },
  { id: "benefit", label: "BenefitPay", icon: "phone_iphone" },
  { id: "qr", label: "QR", icon: "qr_code" }, // ✅ New QR payment method
];

export const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = ({
  selectedPayment,
  onSelectPayment,
}) => {
  const theme = useTheme();
  const [openQrOptionModal, setOpenQrOptionModal] = useState(false);

  const fadeInAnimation = {
    animation: "fadeIn 0.3s ease-in-out",
    "@keyframes fadeIn": {
      "0%": {
        opacity: 0,
        transform: "translateX(-10px)",
      },
      "100%": {
        opacity: 1,
        transform: "translateX(0)",
      },
    },
  };

  const paperStyles = (isSelected: boolean) => ({
    flex: 1,
    p: 1.5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    cursor: "pointer",
    backgroundColor: isSelected
      ? alpha("#1E8078", 0.1)
      : alpha(theme.palette.divider, 0.05),
    borderRadius: 1,
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: alpha("#1E8078", 0.1),
    },
  });

  return (
    <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
      {PAYMENT_METHODS.map((method) => (
        <Paper
          key={method.id}
          elevation={0}
          onClick={() => onSelectPayment(method.id)}
          sx={paperStyles(selectedPayment === method.id)}
        >
          <Icon
            sx={{
              color: selectedPayment === method.id ? "#1E8078" : "action",
            }}
          >
            {method.icon}
          </Icon>
          {selectedPayment === method.id && (
            <Typography
              sx={{
                color: "#1E8078",
                fontWeight: 600,
                ...fadeInAnimation,
              }}
            >
              {method.label}
            </Typography>
          )}
        </Paper>
      ))}
    </Stack>
  );
};